
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">AI虚拟人的智能交互与个性化服务</h2>
                    <div class="time">2023-08-07 11:00:10</div>
                    <div class="start">
                        随着人工智能技术的不断发展，AI虚拟人成为了现实生活中的一部分。深圳羽迹科技有限公司作为该领域的先驱者，致力于将AI虚拟人的智能交互与个性化服务推向更高的境界。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/222.png" alt="AI虚拟人的智能交互与个性化服务" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            AI虚拟人是一种通过人工智能技术模拟人类思维和行为的虚拟存在。通过语音、图像和文本等多种形式，AI虚拟人能够与人类进行智能交互。深圳羽迹科技有限公司利用先进的自然语言处理、计算机视觉和机器学习技术，打造了高度智能的AI虚拟人系统。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            智能交互是AI虚拟人的核心功能之一。通过深度学习算法和大数据分析，AI虚拟人能够理解人类的语音和文本输入，并作出准确的回应。无论是语音助手、在线客服还是虚拟健身教练，AI虚拟人都能够提供快速、便捷且准确的解决方案。与传统的机器人相比，AI虚拟人更具人性化，能够模拟人类的情感和表情，使得交互更加自然和亲切。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            个性化服务是AI虚拟人的另一个重要特点。深圳羽迹科技有限公司通过建立大规模用户数据库和智能分析系统，为每个用户提供个性化的服务体验。AI虚拟人能够根据用户的需求和偏好，推荐合适的产品、提供定制化的建议，并实时调整服务策略。通过不断学习和优化，AI虚拟人能够与用户建立更加紧密的连接，提供更加贴心的服务。
                        </div>
                    </div>


                    <div class="end">
                        AI虚拟人的应用场景非常广泛。在教育领域，AI虚拟人可以成为学生的学习伴侣，提供个性化的学习指导和答疑解惑。在医疗健康领域，AI虚拟人可以为患者提供健康管理建议和药物咨询，提高医疗服务的效率和质量。在零售行业，AI虚拟人可以为顾客提供个性化的购物建议和推荐，增强用户购物体验。这些应用场景只是冰山一角，随着技术的不断进步，AI虚拟人将在更多领域发挥作用。
                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "AI虚拟人的智能交互与个性化服务-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "AI虚拟人的智能交互与个性化服务,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "随着人工智能技术的不断发展，AI虚拟人成为了现实生活中的一部分",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo222.vue